import { gql } from '@apollo/client';

export const ProductDetailsFragment = gql`
  fragment ProductDetailsFragment on ProductInterface {
    __typename
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    categories {
      uid
      name
      breadcrumbs {
        category_uid
        category_name
        category_level
      }
    }
    presale_product {
      status
      label
      note
    }
    description {
      html
    }
    short_description {
      html
    }
    id
    uid
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    media_gallery_entries {
      uid
      label
      position
      disabled
      file
      url(type: "image", width: 670, height: 670)
    }
    # media_gallery {
    #     label
    #     url(type: "thumbnail", width: 120, height: 120)
    #     position
    #     disabled
    # }
    features {
      type
      imgUrl
    }
    video_url
    # meta_description
    # meta_title
    # meta_keyword
    name
    product_size_chart {
      identifier
      title
      content
    }
    price {
      regularPrice {
        amount {
          currency
          value
        }
      }
    }
    prices {
      finalPrice {
        currency
        value
      }
      regularPrice {
        currency
        value
      }
      # ChildrenPrices {
      #     child_product_id
      #     sku
      #     finalPrice {
      #         currency
      #         value
      #     }
      #     regularPrice {
      #         currency
      #         value
      #     }
      # }
    }
    # TODO shizheng
    # related_products {
    #     id
    #     uid
    #     name
    #     sku
    #     price {
    #         regularPrice {
    #             amount {
    #                 currency
    #                 value
    #             }
    #         }
    #     }
    #     stock_status
    #     url_key
    #     price_range {
    #         maximum_price {
    #             final_price {
    #                 currency
    #                 value
    #             }
    #             discount {
    #                 amount_off
    #             }
    #             regular_price {
    #                 currency
    #                 value
    #             }
    #         }
    #         minimum_price {
    #             final_price {
    #                 currency
    #                 value
    #             }
    #             regular_price {
    #                 currency
    #                 value
    #             }
    #             discount {
    #                 amount_off
    #             }
    #         }
    #     }
    #     prices {
    #         finalPrice {
    #             currency
    #             value
    #         }
    #         regularPrice {
    #             currency
    #             value
    #         }
    #         ChildrenPrices {
    #             child_product_id
    #             sku
    #             finalPrice {
    #                 currency
    #                 value
    #             }
    #             regularPrice {
    #                 currency
    #                 value
    #             }
    #         }
    #     }
    #     rating_summary
    #     small_image {
    #         url(type: "thumbnail")
    #     }
    #     hover_image
    # }
    price_range {
      maximum_price {
        final_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
    }
    # men_size_info {
    #     label
    #     sku
    # }
    # women_size_info {
    #     label
    #     sku
    # }
    sku
    small_image {
      url(type: "thumbnail", width: 90, height: 90)
    }
    stock_status
    url_key
    # custom_attributes {
    #     selected_attribute_options {
    #         attribute_option {
    #             uid
    #             label
    #             is_default
    #         }
    #     }
    #     entered_attribute_value {
    #         value
    #     }
    #     attribute_metadata {
    #         uid
    #         code
    #         label
    #         attribute_labels {
    #             store_code
    #             label
    #         }
    #         data_type
    #         is_system
    #         entity_type
    #         ui_input {
    #             ui_input_type
    #             is_html_allowed
    #         }
    #         ... on ProductAttributeMetadata {
    #             used_in_components
    #         }
    #     }
    # }
    ... on CustomizableProductInterface {
      options {
        uid
        required
        title
        sort_order
        ... on CustomizableRadioOption {
          uid
          title
          option_id
          value {
            title
            option_type_id
            uid
          }
        }
      }
    }
    ... on ConfigurableProduct {
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      configurable_options {
        attribute_code
        attribute_id
        uid
        label
        position
        product_id
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        values {
          uid
          default_label
          label
          store_label
          use_default_value
          value_index
          swatch_data {
            ... on ImageSwatchData {
              thumbnail
            }
            value
          }
        }
      }
      variants {
        attributes {
          code
          value_index
        }
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        product {
          id
          uid
          # presale_product {
          #     status
          #     label
          #     note
          # }
          # eslint-disable-next-line @graphql-eslint/require-id-when-available
          media_gallery_entries {
            uid
            disabled
            file
            label
            position
            url(type: "image", width: 670, height: 670)
          }
          # media_gallery {
          #     label
          #     url(type: "thumbnail", width: 120, height: 120)
          #     position
          #     disabled
          # }
          sku
          stock_status
          price {
            regularPrice {
              amount {
                currency
                value
              }
            }
          }
          prices {
            finalPrice {
              currency
              value
            }
            regularPrice {
              currency
              value
            }
            # ChildrenPrices {
            #     child_product_id
            #     sku
            #     finalPrice {
            #         currency
            #         value
            #     }
            #     regularPrice {
            #         currency
            #         value
            #     }
            # }
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              discount {
                amount_off
              }
            }
          }
          # custom_attributes {
          #     selected_attribute_options {
          #         attribute_option {
          #             uid
          #             label
          #             is_default
          #         }
          #     }
          #     entered_attribute_value {
          #         value
          #     }
          #     attribute_metadata {
          #         uid
          #         code
          #         label
          #         attribute_labels {
          #             store_code
          #             label
          #         }
          #         data_type
          #         is_system
          #         entity_type
          #         ui_input {
          #             ui_input_type
          #             is_html_allowed
          #         }
          #         ... on ProductAttributeMetadata {
          #             used_in_components
          #         }
          #     }
          # }
        }
      }
    }
  }
`;

export const ProductReviewsFragment = gql`
  fragment ProductReviewsFragment on ProductInterface {
    __typename
    url_key
    rating_summary
    review_count
    ratingStars {
      star
      count
    }
    uid
    reviews(sort: $sort, currentPage: $review_current_page, pageSize: $pageSize, filter: $filter, search: $search) {
      items {
        id
        summary
        text
        nickname
        created_at
        erp_review_id
        product_id
        review_image {
          id
          url
        }
        review_helpful(ip: $ip) {
          items {
            id
            is_help
            is_not_help
            is_owner
          }
          is_help_count
          is_not_help_count
        }
        average_rating
        ratings_breakdown {
          name
          value
        }
        video_url {
          url
        }
      }
      page_info {
        page_size
        current_page
        total_pages
      }
    }
  }
`;
